import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// 🔹 Create Sales Target API
export const createSalesTargetApi = createAsyncThunk(
  "createSalesTarget",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/salesTarget/create",
        payload, // JSON object pass hoga
        {
          headers: {
            "Content-Type": "application/json",
            // Agar token har jagah axiosInstance me auto set nahi hai to yahan add karein:
            // Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const createSalesTargetSlice = createSlice({
  name: "createSalesTarget",
  initialState: {
    // data: null,
    createSalesTarget: [], // ✅ object rakho (array ki jagah)
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSalesTargetApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSalesTargetApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(createSalesTargetApi.rejected, (state, action) => {
        state.error = action.payload || action.error.message;
        state.loading = false;
      });
  },
});

export default createSalesTargetSlice.reducer;

// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../../utils/axiosInstance";

// export const createSalesTargetApi = createAsyncThunk("createSalesTarget", async (formData) => {
//     const response = await axiosInstance.post("/salesTarget/create", formData, {
//         headers: {
//             "Content-Type": "multipart/form-data",
//         },
//     });
//     return response.data;
// });

// const createSalesTargetSlice = createSlice({
//     name: "createSalesTarget",
//     initialState: {
//         createSalesTarget: [],
//         errors: [],
//         loading: false,
//     },
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(createSalesTargetApi.pending, (state) => {
//                 state.loading = true;
//             })
//             .addCase(createSalesTargetApi.fulfilled, (state, action) => {
//                 state.createSalesTarget = action.payload;
//                 state.loading = false;
//             })
//             .addCase(createSalesTargetApi.rejected, (state, action) => {
//                 state.errors = action.payload || action.error.message;
//                 state.loading = false;
//             });
//     },
// });

// export default createSalesTargetSlice.reducer;
